import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    user
  },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    maindataImgs: state => state.user.maindataImgs,
    maindata: state => state.user.maindata,
    signInfo: state => state.user.signinInfo,
    continueSign: state => state.user.continueSign,
    hasSigned:  state => state.user.hasSigned,
    hotwordConfigs: state => state.user.hotwordConfigs,
    tjzlszConfigs: state => state.user.tjzlszConfigs,
  },
  state: {},
  mutations: {},
  actions: {}
})
